class AuditController {

    constructor($rootScope, $state, authService, auditService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.authService = authService;
        this.auditService = auditService;
        // $ngRedux.connect(function(state){ return {user: state.user} })(this);
    }

    $onInit() {
        this.auditService.find(this.class, this.id)
            .then(response => {
                this.audits = response;
            });
    }
}

AuditController.$inject = [ '$rootScope', '$state', 'authService', 'auditService' ];

export default AuditController;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/controllers/audit.controller.js